import { FC } from 'react';
import { AdminDashboard } from './AdminDashboard';
import { StandardDashboard } from './StandardDashboard';
import { GuardedRender } from '@components/portal/common';

export const Dashboard: FC = () => {
	return (
		<GuardedRender canRender={(user) => user.isAdmin()} fallback={<StandardDashboard />}>
			<AdminDashboard />
		</GuardedRender>
	);
};
